import React from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'

const Container = styled(Link)`
	display: flex;
	align-items: center;
	color: rgb(0,0,0,.4);
	margin-bottom: 25px;
	font-size: .8rem;
	transition-duration: .1s;
	&:hover {
		color: rgb(0,0,0,.8);
	}
`


export default () => (
	<Container to="/">
		<svg width="20" height="20" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
		  <path stroke="none" d="M0 0h24v24H0z"/>
		  <polyline points="15 6 9 12 15 18" />
		</svg>
		<span>
			Back to Browse
		</span>
	</Container>
)